import * as Remarkable from 'remarkable';
import * as _ from 'lodash-es';
import { RootScope } from './types/angular-types';
import { debounce } from 'lodash-es';
import * as moment from 'moment';
import * as $ from 'jquery';
import * as fileTypeMap from './shared/fileTypeMap';
import Features from './feature-manager/Features';
import AppConstants from './gorillaboy/AppConstants';
import { MetricService, BrowserService, LoggingService, MetricServiceModule } from '@amzn/aws-workdocs-web-client-common';
import { CompanionClientService } from "./companionClient/companionClient";
import { CompanionClient, getWarpDriveOAuth2LoginUrl, getWorkdocsServiceUrl } from '@amzn/aws-workdocs-web-companion-common';
import { CompanionClientEventHandlerService } from './companionClient/companionClientEventHandler';

//Delete the Session Info Storage key in LocalStorage. One time thing for next release.
localStorage.removeItem('local_session_info_storage');

const { angular } = window as any;

// Jquery: Increase CORS compatibility for IE
$.support.cors = true;

angular.module('GorillaBoy.services').factory('BrowserService', [() => BrowserService]);

// Declare app level module which depends on filters, and services
angular.module('GorillaBoy')

    .config(['$httpProvider', '$compileProvider', '$provide', '$translateProvider', 'Strings', 'localStorageServiceProvider', '$controllerProvider', '$uibTooltipProvider', '$locationProvider',
        function ($httpProvider, $compileProvider, $provide, $translateProvider, Strings, localStorageServiceProvider, $controllerProvider,
            $uibTooltipProvider, $locationProvider) {
            $locationProvider.hashPrefix(''); //Remove the default hash prefix which is '!'
            $httpProvider.defaults.cache = false;

            // Prevent GET request caching in IE
            $httpProvider.defaults.headers.common['Cache-Control'] = 'no-cache';
            $httpProvider.defaults.headers.common.Pragma = "no-cache";

            $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|workdocs):/);

            $uibTooltipProvider.setTriggers({
                'mouseenter': 'mouseleave'
            });
            $uibTooltipProvider.options({
                //show the tooltips only after user hovers over the trigger elements for atleast 500ms
                //Why 750ms, because that's the minium ms user hovers over something to "reveal" it's hidden meaning.
                //Lowering the ms will show the tooltip too soon unwantedly
                popupDelay: 750
            });

            var language = (window as any).determinePreferredLanguage();
            (window as any).workdocsLanguage = language;

            //Moment JS has locale's in lowercase.
            moment.locale(language.toLowerCase());

            $translateProvider
                .translations(language, Strings.TranslatedStrings[language])
                .translations("en", Strings.TranslatedStrings.en)
                .preferredLanguage(language)
                .fallbackLanguage('en')
                .addInterpolation('$translateMessageFormatInterpolation')
                .useSanitizeValueStrategy('escapeParameters');

            localStorageServiceProvider.setPrefix('');

            $controllerProvider.allowGlobals();

            // Override the error Handler to capture JS errors for metrics
            // These will be combined with session metrics before they are sent
            // to the sever.
            // (TODO: Refactor this into a Provider)
            $provide.decorator('$exceptionHandler', ['$delegate', '$window', '$log', function ($delegate, $window, $log) {

                return function (exception, cause) {

                    var MAX_ERRORS = 25,
                        localStorageGlobalClientErrors;
                    try {
                        localStorageGlobalClientErrors = $window.localStorage.getItem(AppConstants.LocalStorageKeys.GLOBAL_CLIENT_ERRORS);
                    } catch (e) {
                        $delegate(exception, cause);
                        return;
                    }

                    if (!localStorageGlobalClientErrors || localStorageGlobalClientErrors === '') {
                        localStorageGlobalClientErrors = [];
                    } else {
                        localStorageGlobalClientErrors = angular.fromJson(localStorageGlobalClientErrors);
                    }

                    if (localStorageGlobalClientErrors.length > MAX_ERRORS) {
                        localStorageGlobalClientErrors.splice(0, 1);
                    }

                    localStorageGlobalClientErrors.push({ message: exception.message, stack: exception.stack, timestamp: new Date().getTime() });
                    try {
                        $window.localStorage.setItem(AppConstants.LocalStorageKeys.GLOBAL_CLIENT_ERRORS, angular.toJson(localStorageGlobalClientErrors));
                    } catch (e) {
                        if (isQuotaExceeded(e)) {
                            // if local storage quota exceeded, remove the Ajax call results.
                            $window.localStorage.removeItem(AppConstants.LocalStorageKeys.AJAX_CALL_RESULTS);
                        }
                        $log.error("Error saving to LocalStorage: " + JSON.stringify(e));
                    }
                    $delegate(exception, cause);
                };

            }]);

            function isQuotaExceeded(e) {
                // This code comes from this blog.
                // http://crocodillon.com/blog/always-catch-localstorage-security-and-quota-exceeded-errors
                var quotaExceeded = false;
                if (e) {
                    if (e.code) {
                        switch (e.code) {
                            case 22:
                                quotaExceeded = true;
                                break;
                            case 1014:
                                // Firefox
                                if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
                                    quotaExceeded = true;
                                }
                                break;
                        }
                    } else if (e.number === -2147024882) {
                        // Internet Explorer 8
                        quotaExceeded = true;
                    }
                }
                return quotaExceeded;
            }

            //The order of these interceptors matters!
            // The intercepters are executed
            // in registration order for requests
            // in reverse registration order for responses
            $httpProvider.interceptors.push('LoggingHttpInterceptor');
            $httpProvider.interceptors.push('AuthRetryInterceptor');
            $httpProvider.interceptors.push('RetryInterceptor');

        }
    ])
    .run(['$q', '$window', '$timeout', '$rootScope', '$location', '$log', '$translate', '$uibModalStack', 'SignalProvider', 'SourceConstant', 'AuthService', 'SessionManager', 'localStorageService', 'authenticatedUser', 'FeatureManagerService', 'UserService', 'OrganizationService', 'ClientMetricsService', 'MetricEvents', 'EndpointConfig', '$sce', 'BrowserService', 'LogoService', 'FileManagerFactory', 'CompanionClientEventHandlerService', 'RegionService', 'CompanionClientService', 'EndpointService',
        function ($q, $window, $timeout, $rootScope: RootScope, $location, $log, $translate, $uibModalStack, SignalProvider, SourceConstant, AuthService, SessionManager, localStorageService, authenticatedUser, FeatureManagerService, UserService, OrganizationService, ClientMetricsService, MetricEvents, EndpointConfig, $sce, BrowserService, LogoService, FileManagerFactory, CompanionClientEventHandlerService: CompanionClientEventHandlerService, RegionService, CompanionClientService: CompanionClientService, EndpointService) {
            var region = RegionService.getRegion(),
                stage = region ? EndpointConfig.stage(region) : null,
                isForwardingService = true;
            ClientMetricsService.startNewSession();

            $rootScope.metricServiceInstance = new MetricService(stage, RegionService.getRealRegion(),
                region, "AWSGorillaBoyWebsite", ClientMetricsService.getCurrentSessionId(),
                window, new LoggingService(window, "AWSGorillaBoyWebsite", stage, RegionService.getRealRegion(), ClientMetricsService.getCurrentSessionId(), null, isForwardingService), isForwardingService);
            if (performance && performance.now) {
                $rootScope.metricServiceInstance.putMetric({
                    MethodName: "TimeToIndexHTMLResponseEnd",
                    MetricName: "Time",
                    Unit: "Milliseconds",
                    Values: performance.now()
                });
            }


            /**
             * There's a vulnerability in Angular Translate library that does not sanitize the values when adding to the DOM.
             * This method should be used when the key has any component that is accepted by the user.
             *
             * For example, take the following key. The layout.folderId is accepted from the user, then it leads to XSS when use directly use the key
             * with "translate" directive.
             * ANALYTICS.SEARCHFOR.MESSAGE.FOLDER = Results for <a href="{{'#/folder/' + layout.folderId}}">{{layout.resourceName}}</a>
             *
             * More details, look here https://github.com/angular-translate/angular-translate/issues/1418
             */
            $rootScope.getTranslatedMessageSafely = function (key, object) {
                return $translate.instant(key, object);
            };

            $log.info(new Date().toISOString() + "[app.module.js] Initializing Application");
            var win = (window as any);
            $rootScope.isPreviewEnabled = function () {
                var featureEnabledState = FeatureManagerService.isFeatureEnabled(Features.UI.PREVIEW_SITE) || false,
                    region = RegionService.getRegion(),
                    isProd,
                    stage;

                stage = EndpointConfig.stage(region);
                isProd = stage === "PROD";
                return isProd && featureEnabledState;
            };

            $rootScope.signUserForNovaMigration = function (forced: boolean) {
                var updatedPreferences: { 'webVersion': string, 'optoutNova': string, 'showRedirectModal'?: string } = { 'webVersion': AppConstants.PreviewSite.WEB_NOVA_PREF, 'optoutNova': 'false' };
                if (forced) {
                    updatedPreferences.showRedirectModal = 'true';
                }
                UserService.updateUserPreferences(authenticatedUser.getUserInfo().Id, updatedPreferences).then(function () {
                    var absUrl = $location.absUrl(),
                        redirectUrl;
                    const rainierPaths = RegExp($rootScope.getRainierURL() + '|' + AppConstants.PreviewSite.PREVIEW_URL_COMPONENT + '|\/#\/');
                    redirectUrl = absUrl.replace(rainierPaths, $rootScope.getNovaURL());
                    $rootScope.metricServiceInstance.putMetric({
                        MethodName: "UserSignedUpForNova",
                        MetricName: "Count",
                        Unit: "Count",
                        Values: 1
                    });
                    $rootScope.changeWindowLocationHref(redirectUrl);
                },
                    function () {
                        $log.error(new Date().toISOString() + ' [LoginController] Failed to update user preference from classic to Nova site');
                    });
            };

            $rootScope.forceUserToNovaMigration = function () {
                $rootScope.metricServiceInstance.newCounterMetric("ForcedUserToNovaMigration");
                $rootScope.signUserForNovaMigration(true);
            }

            $rootScope.isNovaMigrationOptionVisible = function () {
                let isMemberOfNovaAllowLists = $rootScope.isMemberOfGroup(AppConstants.NovaOnboardingGroups.BRAVEHEARS_OPT_IN) ||
                    $rootScope.isMemberOfGroup(AppConstants.NovaOnboardingGroups.BRAVEHEARS_OPT_IN_EXTENSION_1) ||
                    $rootScope.isMemberOfGroup(AppConstants.NovaOnboardingGroups.BRAVEHEARS_OPT_IN_EXTENSION_2);
                if (FeatureManagerService.isFeatureEnabled(Features.UI.NOVA_KILL_SWITCH)) {
                    return false;
                }
                if ($rootScope.AwsAccountStatus === 'INTERNAL'){
                    return true;
                }
                if (!FeatureManagerService.isFeatureEnabled(Features.UI.NOVA_ENABLED)) {
                    return false;
                }
                if (FeatureManagerService.isFeatureEnabled(Features.UI.NOVA_ENABLED_AWS) && EndpointConfig.isAmazonSite() && $rootScope.isMemberOfGroup(AppConstants.NovaOnboardingGroups.ALL_AWS_EMPLOYEES)) {
                    return true;
                }
                return FeatureManagerService.isFeatureEnabled(Features.UI.NOVA_ENABLED_AMAZON_CORP_SITE) || isMemberOfNovaAllowLists;
            }

            $rootScope.isBannerVisible = function () {
                return $rootScope.isNovaMigrationOptionVisible() && FeatureManagerService.isFeatureEnabled(Features.UI.NOVA_REDIRECT_BANNER_VISIBLE);
            }

            $rootScope.migrateDataBannerVisible = false;
            $rootScope.isMigrateDataBannerVisible = async () => {
                const admin = authenticatedUser.getUserInfo().Administrator;
                $rootScope.isAdmin = !!admin;
                let isVisible = false;
                let isExternal = false;
                try {
                    if(!$rootScope.AwsAccountStatus){
                        const orgResponse = await OrganizationService.getOrganization();
                        isExternal = orgResponse.data.Organization.AwsAccountStatus !== 'INTERNAL';
                        $rootScope.AwsAccountStatus = orgResponse.data.Organization.AwsAccountStatus;
                        const logger = $rootScope.metricServiceInstance.getLogger() as any;
                        if(logger){
                            logger.log(`Organizational Data: ${orgResponse.data.Organization.AwsAccountId} is ${orgResponse.data.Organization.AwsAccountStatus}`)
                        }
                    } else {
                        isExternal = $rootScope.AwsAccountStatus !== 'INTERNAL'
                    }
                    isVisible = isExternal && (admin || FeatureManagerService.isFeatureEnabled(Features.UI.MIGRATE_DATA_BANNER_VISIBLE));
                    $rootScope.migrateDataBannerVisible = isVisible;
                } catch (error) {
                    $rootScope.metricServiceInstance.newCounterMetric('Get_Organization_Error', 1);
                }
                if (admin) {
                    $rootScope.metricServiceInstance.newCounterMetric((isVisible ? "ShouldSeeMigrateDataBanner" : "ShouldNotSeeMigrateDataBanner"));
                } else {
                    $rootScope.metricServiceInstance.newCounterMetric((isVisible ? "ShouldSeeMigrateDataBanner_AllUsers" : "ShouldNotSeeMigrateDataBanner_AllUsers"));
                }
                return isVisible;
            }

            $rootScope.acknowledgeMigrationAndUpdatePreference = async () => {
                $rootScope.displayMigrationModal = false;
                const { UserPreferences } = await UserService.getUserPreferences(authenticatedUser.getUserInfo().Id)
                try {
                    UserService.updateUserPreferences(authenticatedUser.getUserInfo().Id, { ...UserPreferences, 'acknowledgedMigrationModalPostSunset': "true" })
                } catch (error) {
                    $rootScope.metricServiceInstance.newCounterMetric("UpdateUserPreferenceAcknowledgePostSunsetError")
                }
                $rootScope.metricServiceInstance.newCounterMetric("AcceptedMigrationAgreementPostSunset")

            }

            $rootScope.shouldPushToNova = async function () {
                var redirectToNova = true,
                    stayInRainier = false;

                return Promise.all([
                    FeatureManagerService.getEnabledFeatureMap(),
                    UserService.getUserPreferences(authenticatedUser.getUserInfo().Id),
                    OrganizationService.getOrganization()
                ]).then((results) => {
                    let featureFlags = results[0],
                        userPreferences = results[1],
                        orgResponse = results[2];
                    if(!$rootScope.AwsAccountStatus){
                      $rootScope.AwsAccountStatus = orgResponse.data.Organization.AwsAccountStatus
                    }
                    if (userPreferences && userPreferences.UserPreferences && featureFlags && orgResponse) {
                        // adding Internal account check here will allow me to enable redirect amazon site for globally
                        if (FeatureManagerService.isFeatureEnabled(Features.UI.REDIRECT_AMAZON_SITE) && orgResponse.data.Organization.AwsAccountStatus === 'INTERNAL') {
                            const redirectRoundTimestamp = getMostRecentRedirectRoundTimestamp(featureFlags);
                            let userPreferenceName = 'leftNova_' + redirectRoundTimestamp;
                            if (userPreferences.UserPreferences[userPreferenceName]) {
                                $rootScope.metricServiceInstance.newCounterMetric("ShouldNOTSeeRedirectPopup");
                                return stayInRainier;
                            } else {
                                $rootScope.metricServiceInstance.newCounterMetric("ShouldSeeRedirectPopup");
                                return redirectToNova;
                            }
                        } else if (FeatureManagerService.isFeatureEnabled(Features.UI.REDIRECT_DILIP_REPORTS) && $rootScope.isMemberOfGroup(AppConstants.NovaOnboardingGroups.DILIP_REPORTS)) {
                            if (userPreferences.UserPreferences['dilipOrgMemberLeft']) {
                                $rootScope.metricServiceInstance.newCounterMetric("ShouldNOTSeeRedirectPopup");
                                return stayInRainier;
                            } else {
                                $rootScope.metricServiceInstance.newCounterMetric("ShouldSeeRedirectPopup");
                                return redirectToNova;
                            }
                        }
                    }
                    $rootScope.metricServiceInstance.newCounterMetric("ShouldNOTSeeRedirectPopup");
                    $rootScope.metricServiceInstance.newCounterMetric("ShouldPushToNova.Success");
                    return stayInRainier;
                })
                    .catch(function (err) {
                        $rootScope.metricServiceInstance.newCounterMetric("ShouldPushToNova.Error");
                        $log.error("Error fetching flags or user preferences: " + JSON.stringify(err));
                    })
            }

            function getMostRecentRedirectRoundTimestamp(featureFlags) {
                let rediretRoundFlagPrefix = 'WorkDocs.UI.PUSH_TO_NOVA_',
                    flagNames: string[] = Object.keys(featureFlags),
                    flagsForRedirectRounds: string[] = [];

                flagNames.forEach(flagName => {
                    if (flagName.startsWith(rediretRoundFlagPrefix)) {
                        flagsForRedirectRounds.push(flagName);
                    }
                })
                flagsForRedirectRounds.sort((a, b) => { return Number(b.split(rediretRoundFlagPrefix)[1]) - Number(a.split(rediretRoundFlagPrefix)[1]) })
                const mostRecentFlag = flagsForRedirectRounds[0];

                return mostRecentFlag ? mostRecentFlag.split(rediretRoundFlagPrefix)[1] : null;
            }

            $rootScope.getNovaURL = function () {
                var region = RegionService.getRegion();
                var stage = region ? EndpointConfig.stage(region) : null;
                switch (stage) {
                    case 'ALPHA':
                        return AppConstants.NovaURLs.ALPHA
                    case 'GAMMA':
                        return AppConstants.NovaURLs.GAMMA
                    case 'PROD':
                    default: {
                        if (FeatureManagerService.isFeatureEnabled(Features.UI.REDIRECT_OFFICIAL_NOVA_AMAZON_WORKDOCS_SITE)) {
                            return AppConstants.NovaURLs.PROD_AMAZON;
                        } else {
                            return AppConstants.NovaURLs.PROD
                        }
                    }
                }
            }

            $rootScope.getRainierURL = function () {
                var region = RegionService.getRegion();
                var stage = region ? EndpointConfig.stage(region) : null;
                switch (stage) {
                    case 'ALPHA':
                        return AppConstants.RainierURLs.ALPHA
                    case 'GAMMA':
                        return AppConstants.RainierURLs.GAMMA
                    case 'PROD':
                    default:
                        return AppConstants.RainierURLs.PROD
                }
            }

            $rootScope.LatencyMetricEntry = MetricServiceModule.LatencyMetricEntry

            //remove previous sort order if any
            localStorageService.remove('sort_order');

            win.remarkableMd = new Remarkable({
                breaks: true,
                linkify: true
            });

            $rootScope.AppConstants = AppConstants;
            $rootScope.Features = Features;

            $rootScope.viewSupportsNewApprovals = (viewType) => {
                return [AppConstants.ViewTypes.OWN_TYPE, AppConstants.ViewTypes.FOLDER_TYPE,
                AppConstants.ViewTypes.SHARED_TYPE, AppConstants.ViewTypes.SHARED_BY_ME_TYPE,
                AppConstants.ViewTypes.FAVORITES, AppConstants.ViewTypes.AWAITING_FEEDBACK_TYPE,
                AppConstants.ViewTypes.OUT_FOR_REVIEW_TYPE].indexOf(viewType) !== -1;
            };

            //There are some links that constructed off of "free form" text. Hence assignging global function on $rootScope
            //to be able to convert such text to URL safe values
            $rootScope.encodeURIComponent = encodeURIComponent;

            $rootScope.reloadPage = function () {
                $window.location.reload();
            };
            $rootScope.isWindowsOS = function () {
                return BrowserService.getOS() === AppConstants.OSTypes.WINDOWS;
            };
            $rootScope.isMacOS = function () {
                return BrowserService.getOS() === AppConstants.OSTypes.MAC;
            };

            $rootScope.isBeforeDeprecationDate = () => {
                const targetDate = new Date('2025-04-25T00:00:00-07:00');
                return new Date() < targetDate;
            }

            $rootScope.changeWindowLocationHref = function (url) {
                if (!/^https:\/\//i.test(url)) {
                    //Invalid URL do not redirect the user browser
                    return;
                }
                //flushLogsToTheServer() is always resolved where as forcePostMetrics() is not. The identity will convert rejection to resolution
                $q.all([ClientMetricsService.flushLogsToTheServer(), $rootScope.metricServiceInstance.forcePostMetrics().then(null, _.identity)])
                    .then(doTheRedirect, doTheRedirect);

                function doTheRedirect() {
                    $window.location.href = url;
                }
            };
            $rootScope.trustAsHtml = function (val) {
                return $sce.trustAsHtml(val);
            };

            $rootScope.isO365FeatureEnabled = function () {
                return FeatureManagerService.isFeatureEnabled(Features.DocumentViewer.O365);
            };

            LogoService.checkIfCustomClientLogoExists();

            // Constants
            var language = $translate.proposedLanguage() || $translate.use(),
                SEARCH_EXCLUSION_PATTERN = new RegExp("(%|&|\\?)", "g"),
                SEARCH_EXCLUSION_SPACE_PATTERN = new RegExp("(/)", "g"),
                DEFAULT_PAGINATION = {
                    nextMarker: '',
                    markerCache: [],
                    markerCacheLocation: 0,
                    orientation: 'FORWARD'
                },
                ORIENTATION = {
                    FORWARD: 'FORWARD',
                    BACKWARD: 'BACKWARD'
                },
                MYDOCS_PATH = '/mydocs',
                SHARED_PATH = '/shared',
                NOTE_PATH = '/myNote',
                SHARED_BY_ME_PATH = '/sharedByMe',
                AWAITING_FEEDBACK_PATH = '/feedback',
                OUT_FOR_REVIEW_PATH = '/review',
                RECYCLE_PATH = '/recycle',
                RECOVERY_PATH = '/recovery',
                SEARCH_PATH = '/search/';

            $rootScope.getBodyClass = function () {
                return language + ' ' + (BrowserService.isIE() || BrowserService.isMSEdge() ? 'browser-ie' : 'browser-non-ie');
            };

            //Master copy of whether left sidebar should be shown/hidden.
            //All layouts should refer to this value instead of defaulting to pop-open the left sidebar
            $rootScope.showLeftSidebar = true;
            $rootScope.THUMBNAIL_VIEW_NO_PREVIEW = 'images/lang/' + language + '/nopreview-large.png';
            $rootScope.THUMBNAIL_PREVIEW_IN_PROGRESS = 'images/lang/' + language + '/previewinprogress-large.png';
            $rootScope.AMAZON_LOADING_IMAGE = 'images/loading-large.gif';
            $rootScope.DRAFT_COLOR = AppConstants.DRAFT_COLOR;
            $rootScope.downloadingComment = {};
            $rootScope.marketplaceUrl = AppConstants.MARKETPLACE_LINK;
            $rootScope.goto = function (path) {
                //Use $location.url() instead of $location.path(). The former will clear search params as well, which is what we want in most cases
                $location.url(path);
            };
            $rootScope.escapeHTML = function (text) {

                if (!!text && text.replace) {
                    text = text.replace('&', '&amp;');
                    text = text.replace("'", '\'');
                    text = text.replace('/', '&#47;');
                    text = text.replace('<', '&lt;');
                    text = text.replace('>', '&gt;');
                }

                return text;
            };

            $rootScope.sanitizeQuery = function (query) {
                return query.replace(SEARCH_EXCLUSION_PATTERN, "").replace(SEARCH_EXCLUSION_SPACE_PATTERN, " ");
            };

            //Deleted the PaginationObject as there are no references to it.

            function getFullNameImpl(user) {
                let workdocsLanguage = (window as any).workdocsLanguage;

                if (workdocsLanguage) {
                    if (workdocsLanguage === 'zh-cn') {
                        return user.Surname + user.GivenName;
                    }
                    if (workdocsLanguage === 'ko' || workdocsLanguage === 'ja') {
                        return user.Surname + " " + user.GivenName;
                    }
                }

                return user.GivenName + " " + user.Surname;
            }

            $rootScope.getFullName = function (user) {
                if (angular.isUndefined(user) || user === null) {
                    user = authenticatedUser.getUserInfo();
                    if (user) {
                        return getFullNameImpl(user);
                    } else {
                        return '';
                    }
                } else {
                    if (!user.GivenName || user.GivenName === "")
                        return user.Username;
                    return getFullNameImpl(user);
                }
            };

            $rootScope.showDocs = function () {
                //Use $location.url() instead of $location.path(). The former will clear search params as well, which is what we want in most cases
                $location.url(MYDOCS_PATH);
            };

            $rootScope.showShared = function () {
                //Use $location.url() instead of $location.path(). The former will clear search params as well, which is what we want in most cases
                $location.url(SHARED_PATH);
            };

            $rootScope.showSharedByMe = function () {
                //Use $location.url() instead of $location.path(). The former will clear search params as well, which is what we want in most cases
                $location.url(SHARED_BY_ME_PATH);
            };

            $rootScope.showFeedback = function () {
                //Use $location.url() instead of $location.path(). The former will clear search params as well, which is what we want in most cases
                $location.url(AWAITING_FEEDBACK_PATH);
            };

            $rootScope.showReview = function () {
                //Use $location.url() instead of $location.path(). The former will clear search params as well, which is what we want in most cases
                $location.url(OUT_FOR_REVIEW_PATH);
            };

            $rootScope.showSearch = function (query) {
                //Use $location.url() instead of $location.path(). The former will clear search params as well, which is what we want in most cases
                $location.url(SEARCH_PATH + query);
            };

            $rootScope.showRecycle = function () {
                //Use $location.url() instead of $location.path(). The former will clear search params as well, which is what we want in most cases
                $location.url(RECYCLE_PATH);
            };

            $rootScope.showRecovery = function () {
                //Use $location.url() instead of $location.path(). The former will clear search params as well, which is what we want in most cases
                $location.url(RECOVERY_PATH);
            };

            $rootScope.showMyNote = function () {
                //Use $location.url() instead of $location.path(). The former will clear search params as well, which is what we want in most cases
                $location.url(NOTE_PATH);
            };

            $rootScope.showFolder = function (folderId, showMyDocs, showRecycleBin) {
                if (showMyDocs) {
                    $rootScope.showDocs();
                } else if (showRecycleBin) {
                    $rootScope.showRecycle();
                } else if (folderId) {
                    //Use $location.url() instead of $location.path(). The former will clear search params as well, which is what we want in most cases
                    $location.url('/folder/' + folderId);
                }
            };

            $rootScope.filterValidDomain = function (domain) {
                var domain_regex = /^[a-zA-Z0-9_-]+(\.[a-zA-Z0-9-]+)+$/;
                return (domain_regex.test(domain));
            };

            $rootScope.filterInvalidDomain = function (domain) {
                return !$rootScope.filterValidDomain(domain);
            };

            $rootScope.filterValidEmail = function (email) {
                var email_regex = /^[-a-zA-Z0-9._+]+@[a-zA-Z0-9.-]+(\.[a-zA-Z]+)+$/;
                return (email_regex.test(email));
            };

            $rootScope.filterInvalidEmail = function (email) {
                return !$rootScope.filterValidEmail(email);
            };

            $rootScope.filterZerolengthStrings = function (input) {
                return (input.length);
            };

            $rootScope.getContentType = function (file) {
                var
                    OCTET_STREAM = 'application/octet-stream',
                    contentType = OCTET_STREAM,
                    extensionRegex = /\.[0-9a-z]+$/i,
                    extension = file.name.toLowerCase().match(extensionRegex);
                if (fileTypeMap[extension]) {
                    contentType = fileTypeMap[extension];
                } else if (file.type) {
                    contentType = file.type;
                }
                return contentType;
            };

            $rootScope.safeApply = function (fn) {
                var phase = this.$root && this.$root.$$phase;
                if (phase == '$apply' || phase == '$digest') {
                    if (fn && (typeof (fn) === 'function')) {
                        fn();
                    }
                } else {
                    this.$apply(fn);
                }
            };

            $rootScope.toggleLeftSidebar = function () {
                $rootScope.$broadcast(SignalProvider.Sidebar.ToggleLeft);
            };

            $rootScope.toggleRightSidebar = function () {
                $rootScope.$broadcast(SignalProvider.Sidebar.ToggleRight);
            };

            $rootScope.toggleRightSidebarWithTab = function (tabName) {
                $rootScope.$broadcast(SignalProvider.Sidebar.ToggleRight, tabName);
            };

            $rootScope.showNewSiteButton = function () {
                if (FeatureManagerService.isFeatureEnabled(Features.UI.SHOW_SITE_SWITCH)) {
                    return !$rootScope.showNewSiteBanner();
                }

                return false;
            };

            $rootScope.getBooleanValueIfInitialized = function (value) {
                if (value === null || typeof (value) == 'undefined' || value === false) {
                    return false;
                }

                return true;
            };

            $rootScope.preFetchSharedWithMeDebounced = _.debounce(function () {
                if (AuthService.isAuthenticated()) {
                    FileManagerFactory.preFetchSharedWithMe();
                }
            }, 30 * 1000, {
                leading: true,
                trailing: false
            });

            $rootScope.isMemberOfGroup = function (groupName) {
                var groups = authenticatedUser.getUserGroups();
                if (groups) {
                    return groups.Groups.map((group) => group.Name).indexOf(groupName) > -1;
                };
                return false;
            }

            // Configures our authentication mechanism for route provider
            $rootScope.$on("$routeChangeStart", function (event, next, current) {
                var requireAuth = next.$$route && next.$$route.auth;

                $log.info("Route change to " + (next.$$route ? next.$$route.originalPath : 'no original path'));

                if (!localStorageService.cookie.isSupported) {
                    // Cookies are disabled, direct to no cookies page
                    $location.path('/no_cookies');
                } else {
                    if (requireAuth) {
                        // Checks if there is an unexpired access token and user info has been loaded.
                        if (AuthService.isAuthenticated()) {
                            // Detect port for frictionless edit and inform FE for new access token
                            if (!CompanionClientService.getClient()) {
                                let logger = $rootScope.metricServiceInstance.getLogger();
                                let userInfo = authenticatedUser.getUserInfo();
                                var orgName = EndpointService.organization();
                                // use any because this issue: https://github.com/microsoft/TypeScript/issues/8346
                                // need deep dive for solution
                                CompanionClientService.setClient(new CompanionClient(
                                    {
                                        region: RegionService.getRealRegion(),
                                        organizationID: userInfo.OrganizationId,
                                        userID: userInfo.Id,
                                        loginUrl: getWarpDriveOAuth2LoginUrl(region, stage, orgName),
                                        workDocsServiceUrl: getWorkdocsServiceUrl(RegionService.getRealRegion(), stage),
                                        browserName: BrowserService.getBrowser(),
                                        browserVersion: BrowserService.getBrowserVersion(),
                                    },
                                    logger as any,
                                    $rootScope.metricServiceInstance as any,
                                    CompanionClientEventHandlerService.getHandler()
                                ))
                            }
                            AuthService.startTokenRefreshTask();
                        } else {
                            // Remove beginning slashes on route match
                            var redirectLocation = window.location.hash.replace(/^#\//g, '');
                            $location.url('/login?redirectPath=' + encodeURIComponent(redirectLocation));
                        }
                    }
                    // No auth required, let Angular complete the normal routing flow
                }

                $uibModalStack.dismissAll();
            });

            // initilize app banner for android device
            const $any = $ as any;
            $any.smartbanner();
        }
    ]);
